<script setup>
    import { ref, computed } from 'vue';
    import AiIntroPage from '@/components/result/ai-literacy-2026/IntroPage.vue';

    const props = defineProps({
        teacherData: Object
    });

    // teacherData를 기반으로 reportData 생성
    const reportData = computed(() => {
        if (!props.teacherData) {
            // 기본값
            return {
                schoolName: "늘푸른초등학교",
                grade: "4",     
                className: "1",  
                totalStudent: "28",
                teacherName: "이정진",
                date: "2026년 7월" ,
                schul_type: "E"
            };
        }

        return {
            schoolName: props.teacherData.schul_nm || "학교명 없음",
            grade: props.teacherData.grade_code || "0",     
            className: props.teacherData.school_cls || "0",  
            totalStudent: props.teacherData.list ? props.teacherData.list.length.toString() : "0",
            teacherName: props.teacherData.teacher_name || "담임교사",
            date: "2026년 7월" ,
            schul_type: props.teacherData.schul_type || "E",//학교급 추가
        };
    });
</script>
<template>
    <div class="report-inner">         
        <AiIntroPage  
            reportType="teacher"         
           :reportData="reportData"
        />
    </div>
</template>